'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import { getSelectedItemId, getSelectedModule, getSelectedRowOrColumn, getHasSelectedUneditableModule, getHasRowOrColumnSelected, getSelectedGridLayoutNode } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { clearSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import { getHeaderActiveItem } from 'ContentEditorUI/redux/selectors/headerSelectors';
import { getDndAreaElement, getDndAreaRowElementByIdInTree } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
import { getWidgetElement } from 'InpageEditorUI/lib/inpage/utils';
import { getHoveredModuleRowOrColumnInfo, getHoveredToolbarInfo } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { setShouldClearHeaderActiveItem } from 'ContentEditorUI/redux/actions/headerActions';
import { getGridNodeElement } from 'layout-dnd-utils/grids/render/domSelectors';
const mapStateToProps = state => ({
  selectedItemId: getSelectedItemId(state),
  selectedModule: getSelectedModule(state),
  hasSelectedUneditableModule: getHasSelectedUneditableModule(state),
  selectedRowOrColumn: getSelectedRowOrColumn(state),
  hasSelectedRowOrColumn: getHasRowOrColumnSelected(state),
  hoveredInfo: getHoveredModuleRowOrColumnInfo(state),
  hoveredToolbarInfo: getHoveredToolbarInfo(state),
  headerActiveItem: getHeaderActiveItem(state),
  selectedGridLayoutNode: getSelectedGridLayoutNode(state)
});
const mapDispatchToProps = {
  clearSelectedItem,
  setShouldClearHeaderActiveItem
};

// Used to blur all focusable things on outside click, other than widget editors (that already have
// outside blur click handlers)
/**
 * @param {Object} props.selectedRowOrColumn (optional)
 * @param {boolean} props.hasSelectedRowOrColumn (required)
 * @param {Function} props.clearSelectedItem (required)
 * @param {string} props.selectedItemId (optional)
 * @param {Object} props.selectedModule (optional)
 * @param {boolean} props.hasSelectedUneditableModule (required)
 * @param {Object} props.hoveredInfo (optional)
 * @param {Object} props.hoveredToolbarInfo (optional)
 * @param {string} props.headerActiveItem (optional)
 * @param {Function} props.setShouldClearHeaderActiveItem (optional)
 */
class BlurListenerContainer extends Component {
  constructor(...args) {
    super(...args);
    this.handleClick = e => {
      const {
        selectedItemId,
        selectedRowOrColumn,
        selectedModule,
        hasSelectedUneditableModule,
        hoveredInfo,
        hoveredToolbarInfo,
        headerActiveItem,
        selectedGridLayoutNode
      } = this.props;
      let elementToCheck;
      if (headerActiveItem) {
        this.props.setShouldClearHeaderActiveItem(true);
      }
      if (hoveredInfo && (hoveredInfo.isModule || hoveredInfo.id === selectedItemId || hoveredInfo.parentId === selectedItemId) || hoveredToolbarInfo && hoveredToolbarInfo.id === selectedItemId || selectedGridLayoutNode && selectedGridLayoutNode.isModule()) {
        return;
      }
      if (selectedRowOrColumn) {
        const selectedParentNode = selectedRowOrColumn.getParent();
        elementToCheck = selectedRowOrColumn.isRow() ? getDndAreaRowElementByIdInTree(selectedParentNode.getName(), selectedRowOrColumn.getName()) : getDndAreaElement(selectedRowOrColumn.getName());
      } else if (hasSelectedUneditableModule) {
        elementToCheck = getWidgetElement({
          name: selectedModule.get('name'),
          type: selectedModule.get('type')
        });

        // Convert from jquery element
        elementToCheck = elementToCheck ? elementToCheck.$widget.get(0) : undefined;
      } else if (selectedGridLayoutNode) {
        elementToCheck = getGridNodeElement(selectedGridLayoutNode);
      }

      // Check to ensure we're not clicking on the same column/row/section/module/gridNode, or within it again.
      if (elementToCheck && !elementToCheck.contains(e.target)) {
        this.props.clearSelectedItem({
          onlyIfSelected: selectedItemId
        });
      }
    };
  }
  componentDidUpdate(prevProps) {
    const {
      hasSelectedUneditableModule,
      hasSelectedRowOrColumn,
      headerActiveItem,
      selectedGridLayoutNode
    } = this.props;
    if (prevProps.hasSelectedRowOrColumn !== hasSelectedRowOrColumn || prevProps.hasSelectedUneditableModule !== hasSelectedUneditableModule || prevProps.headerActiveItem !== headerActiveItem || prevProps.selectedGridLayoutNode !== selectedGridLayoutNode) {
      if (hasSelectedRowOrColumn || hasSelectedUneditableModule || headerActiveItem || selectedGridLayoutNode) {
        this.attachEventListeners();
      } else {
        this.removeEventListeners();
      }
    }
  }
  componentWillUnmount() {
    this.removeEventListeners();
  }
  attachEventListeners() {
    // Make sure the blur click happens before other handlers
    const useCapture = true;
    document.addEventListener('click', this.handleClick, useCapture);
  }
  removeEventListeners() {
    const useCapture = true;
    document.removeEventListener('click', this.handleClick, useCapture);
  }
  render() {
    return null;
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(BlurListenerContainer);